import { render, staticRenderFns } from "./RegisterOnStaff.vue?vue&type=template&id=308a605d&scoped=true"
import script from "./RegisterOnStaff.vue?vue&type=script&lang=js"
export * from "./RegisterOnStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a605d",
  null
  
)

export default component.exports